
(function(){
'use strict';
if(window.__twCollectionFastFiltersV2)return;
window.__twCollectionFastFiltersV2=true;

function stateFrom(button){
 var section=button.closest('.facest-filters-section');
 if(!section)return null;
 return {section:section,toolbar:button.closest('.m-collection-toolbar'),popup:section.querySelector('[data-tw-inline-filters]')};
}
function close(popup,toolbar){
 if(!popup||!toolbar)return;
 popup.hidden=true;
 popup.querySelectorAll('[data-tw-inline-panel]').forEach(function(panel){panel.hidden=true});
 toolbar.querySelectorAll('[data-tw-quick-filter-action]').forEach(function(btn){btn.setAttribute('aria-expanded','false')});
}
function active(popup){return popup&&popup.querySelector('[data-tw-inline-panel]:not([hidden])');}

/* One badge per quick filter; Filter shows the total active selections. */
function updateFilterCountBadges(section){
 if(!section)return;
 var popup=section.querySelector('[data-tw-inline-filters]');
 if(!popup)return;
 var allKeys=new Set();
 var total=0;

 function badge(key,count){
  var button=section.querySelector('[data-tw-quick-filter-action="'+key+'"]');
  if(!button)return;
  var counter=button.querySelector('.tw-collection-quickfilters__count');
  if(!counter){
   counter=document.createElement('span');
   counter.className='tw-collection-quickfilters__count';
   counter.setAttribute('aria-hidden','true');
   var arrow=button.querySelector('svg');
   if(arrow)button.insertBefore(counter,arrow);
   else button.appendChild(counter);
  }
  counter.textContent=String(count);
  counter.hidden=count===0;
 }
 ['gender','colors','size'].forEach(function(group){
  var count=0;
  popup.querySelectorAll('[data-tw-inline-panel="'+group+'"] input[data-tw-fast-param]').forEach(function(input){
   allKeys.add(input.dataset.twFastParam);
   if(input.checked)count+=1;
  });
  badge(group,count);
  total+=count;
 });
 /* Include applied filters outside the quick categories (e.g. price). */
 var params=new URLSearchParams(window.location.search);
 params.forEach(function(value,key){
  if(key.indexOf('filter.')===0&&!allKeys.has(key)&&value.trim())total+=1;
 });
 badge('all',total);
}
function open(button){
 var state=stateFrom(button);
 if(!state||!state.toolbar||!state.popup)return;
 var action=button.getAttribute('data-tw-quick-filter-action');
 if(action==='all'){
  close(state.popup,state.toolbar);
  var drawer=state.section.querySelector('.m-sidebar--open');
  if(drawer)drawer.click();
  return;
 }
 var wasOpen=!state.popup.hidden && active(state.popup) && active(state.popup).getAttribute('data-tw-inline-panel')===action;
 close(state.popup,state.toolbar);
 if(wasOpen)return;
 state.popup.hidden=false;
 var panel=state.popup.querySelector('[data-tw-inline-panel="'+action+'"]');
 if(panel)panel.hidden=false;
 var empty=state.popup.querySelector('[data-tw-inline-empty]');
 if(empty)empty.hidden=!!panel;
 button.setAttribute('aria-expanded','true');
}
function buildURL(section){
 var popup=section.querySelector('[data-tw-inline-filters]');
 if(!popup)return null;
 var url=new URL(window.location.href);
 var params=url.searchParams;
 var controls=popup.querySelectorAll('[data-tw-fast-param]');
 var keys=new Set();
 controls.forEach(function(input){keys.add(input.dataset.twFastParam)});
 keys.forEach(function(key){params.delete(key)});
 controls.forEach(function(input){
  if(input.checked&&!input.disabled)params.append(input.dataset.twFastParam,input.value);
 });
 var sort=popup.querySelector('input[name="tw-fast-sort"]:checked');
 if(sort)params.set('sort_by',sort.value);
 params.delete('page');
 return url;
}
function submit(button){
 var section=button.closest('.facest-filters-section');
 if(!section)return;
 var url=buildURL(section);
 if(!url)return;
 window.location.assign(url.toString());
}
function clearActive(button){
 var state=stateFrom(button);
 if(!state||!state.popup)return;
 var panel=active(state.popup);
 if(!panel)return;

 var isSort=panel.getAttribute('data-tw-inline-panel')==='sort';
 if(!isSort){
  panel.querySelectorAll('input[type="checkbox"]').forEach(function(input){
   input.checked=false;
  });
  updateFilterCountBadges(state.section);
 }

 // Clear applies immediately. Preserve the other selections and preview-theme URL.
 var url=buildURL(state.section);
 if(!url)return;
 if(isSort)url.searchParams.delete('sort_by');
 url.searchParams.delete('page');
 window.location.assign(url.toString());
}
document.addEventListener('click',function(event){
 var button=event.target.closest&&event.target.closest('[data-tw-quick-filter-action], [data-tw-inline-apply], [data-tw-inline-clear]');
 if(!button||window.innerWidth>=768)return;
 if(button.hasAttribute('data-tw-quick-filter-action')){
  event.preventDefault();open(button);
 }else if(button.hasAttribute('data-tw-inline-apply')){
  event.preventDefault();submit(button);
 }else if(button.hasAttribute('data-tw-inline-clear')){
  event.preventDefault();clearActive(button);
 }
});
document.addEventListener('change',function(event){
 var popup=event.target.closest&&event.target.closest('[data-tw-inline-filters]');
 if(popup)updateFilterCountBadges(popup.closest('.facest-filters-section'));
});
function initialiseFilterCountBadges(){
 document.querySelectorAll('.facest-filters-section').forEach(updateFilterCountBadges);
}
if(document.readyState==='loading'){
 document.addEventListener('DOMContentLoaded',initialiseFilterCountBadges,{once:true});
}else initialiseFilterCountBadges();
window.addEventListener('pageshow',initialiseFilterCountBadges);
document.addEventListener('shopify:section:load',initialiseFilterCountBadges);
document.addEventListener('keydown',function(event){
 if(event.key!=='Escape')return;
 var popup=document.querySelector('.facest-filters-section [data-tw-inline-filters]:not([hidden])');
 if(!popup)return;
 close(popup,popup.closest('.m-collection-toolbar'));
});
document.addEventListener('click',function(event){
 if(event.target.closest&&event.target.closest('.tw-collection-quickfilters, .tw-collection-inline-filters'))return;
 var popup=document.querySelector('.facest-filters-section [data-tw-inline-filters]:not([hidden])');
 if(popup)close(popup,popup.closest('.m-collection-toolbar'));
});
})();
